import React from 'react';
import { Dropdown } from '../../../../ui/components/Dropdown';
import { Icon } from '../../../../ui/icons';
import { IconType } from '../../../../ui/icons/Icon';

interface FilterDropdownProps {
  icon: React.ReactNode;
  innerContent: React.ReactNode;
  dropdownContent: React.ReactNode;
  badge?: number;
  width?: string;
}

export default function FilterDropdown({ icon, innerContent, dropdownContent, badge, width }: FilterDropdownProps) {
  const [open, setOpen] = React.useState(false);

  return (
    <Dropdown width={width} maxHeight={480} dropdown={dropdownContent} open={open} setOpen={open => setOpen(open)}>
      <div
        className='flex w-full cursor-pointer items-center justify-between gap-2 rounded-2 border border-gray-default stroke-gray-900 px-2 hover:bg-gray-subtle'
        onClick={event => {
          event.stopPropagation();
          setOpen(!open);
        }}
      >
        <div className='flex items-center gap-2 overflow-hidden'>
          {icon}
          {innerContent}
        </div>
        <Icon type={IconType.chevronDown} size={'size-4'} />
      </div>
    </Dropdown>
  );
}
